const SVG_CACHE = new Map();

const fetchPromiseValue = fetchPromise => fetchPromise.then(response => response.text());

export default async (url) => {
  if (!SVG_CACHE.has(url)) {
    SVG_CACHE.set(url, fetchPromiseValue(fetch(url)));
  }
  return SVG_CACHE.get(url);
};
